import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ClientCompaniesRateCardsLayout = lazy(() => import('@/pages/reports/client-companies-rate-cards/layout'));
const JobsReportLayout = lazy(() => import('@/pages/reports/jobs/layout'));
const TtiReportLayout = lazy(() => import('@/pages/reports/tti-report/layout'));

// Lazy load report pages
const ClientCompaniesRateCardsPage = lazy(() => import('@/pages/reports/client-companies-rate-cards'));
const JeopardyReportPage = lazy(() => import('@/pages/reports/jeopardy-report'));
const JobsAgGridPage = lazy(() => import('@/pages/reports/jobs'));
const ProjectsDashboardPage = lazy(() => import('@/pages/reports/projects-dashboard'));
const RevenueForecastPage = lazy(() => import('@/pages/reports/revenue-forecast'));
const TtiReportPage = lazy(() => import('@/pages/reports/tti-report'));
const WorkableForecastReportPage = lazy(() => import('@/pages/reports/workable-forecast-report'));
const WorkforceForecastPage = lazy(() => import('@/pages/reports/workforce-forecast'));
const AgingCXReportPage = lazy(() => import('@/pages/reports/aging-cx-report'));

/**
 * Report routes
 * Handles various reporting features
 */
export const reportRoutes: RouteConfig = {
  path: '/reports',
  layout: DashboardLayout,
  children: [
    {
      path: '/client-companies-rate-cards',
      layout: ClientCompaniesRateCardsLayout,
      element: ClientCompaniesRateCardsPage,
    },
    {
      path: '/jeopardy-report',
      element: JeopardyReportPage,
    },
    {
      path: '/jobs',
      layout: JobsReportLayout,
      element: JobsAgGridPage,
    },
    {
      path: '/projects-dashboard',
      element: ProjectsDashboardPage,
    },
    {
      path: '/revenue-forecast',
      element: RevenueForecastPage,
    },
    {
      path: '/tti-report',
      layout: TtiReportLayout,
      element: TtiReportPage,
    },
    {
      path: '/workable-forecast-report',
      element: WorkableForecastReportPage,
    },
    {
      path: '/workforce-forecast',
      element: WorkforceForecastPage,
    },
    {
      path: '/aging-cx',
      element: AgingCXReportPage,
    },
  ],
};
